import { Drawer } from "@material-ui/core";
import React from "react";
import { RemarkTypes } from "../../../../../Enums/RemarkTypes";
import { useStyles } from "../../RequestOrderList/styles";
import PbhRequestOrderNotes from "./PbhRequestOrderNotes";
import "../style.css";

export const RequestRemark = (props: any) => {
  const { isMatchCreate, setIsMatchCreate, requestRemark } = props;
  const classes = useStyles();
  const handleClose = value => {
    setIsMatchCreate?.(false);
    props?.handleClose?.();
  };

  return (
    <Drawer
      variant="persistent"
      open={isMatchCreate}
      anchor="right"
      onClose={handleClose}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      {isMatchCreate ? (
        <PbhRequestOrderNotes
          onCancel={handleClose}
          request={requestRemark}
          resource="pbhrequestremarks"
          basePath="pbhrequestremarks"
          remarkType={RemarkTypes.PbhNote}
          onSuccess={props?.onSuccess}
        />
      ) : null}
    </Drawer>
  );
};
export default RequestRemark;
